<div class="Main_{{Companyname}}" appDisabledRightClick>
  <app-header-jm (isCollapseMenu)="FnIsCollapseSideMenu($event)" *ngIf="!isComprehensivePage"></app-header-jm>
  <router-outlet></router-outlet>
</div>
<div class="modal" id="AlertModal" data-backdrop="static" data-keyboard="false" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="AlertModalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="SessionModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div class="modal-body AlertModalBody">
        Your session has been expired.
      </div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer" routerLinkActive='active'>Okay</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="CommonInfoModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="InfoModalContent" class="modal-body AlertModalBody InfoModal"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="NotAuthmodal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="NotAuthmodalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer" routerLink="/employee-dashboard"
          routerLinkActive="active">Okay</button>
      </div>
    </div>
  </div>
</div>


<a id="return-to-top" *ngIf="showScrollBtn" [@fadeAnimation] appDisabledRightClick (click)="scrollToTop()">
  <svg class="progress-ring" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <!-- Solid blue-gray fill background -->
    <circle cx="24" cy="24" r="20" fill="#6996A6"/>
    <!-- Track ring (translucent) -->
    <circle cx="24" cy="24" r="20" fill="none" stroke="rgba(255,255,255,0.25)" stroke-width="3"/>
    <!-- Progress ring (orange) -->
    <circle class="progress-ring__fill" cx="24" cy="24" r="20" fill="none"
      stroke="#F17E2C" stroke-width="3" stroke-linecap="round"
      [attr.stroke-dasharray]="ringCircumference"
      [attr.stroke-dashoffset]="ringDashoffset"
      transform="rotate(-90 24 24)"/>
    <!-- White arrow -->
    <line x1="24" y1="31" x2="24" y2="17" stroke="white" stroke-width="2.2" stroke-linecap="round"/>
    <polyline points="18,23 24,17 30,23" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  </svg>
</a>

<!-- <button _ngcontent-det-c147="" class="CommonSubmitButton Button_n ng-star-inserted">
      <i class="fa fa-arrow-up" aria-hidden="true"></i> Back to Top </button>    -->

<div *ngIf="Loader.visible" appDisabledRightClick>
  <div class="overlay overlay_white">
    <img [src]='loader' [style.width]="loaderWidth" [style.height]="loaderHeight" />
    <br/>
    <h3>{{LoaderText}}</h3>
  </div>
</div>

<div *ngIf="Loader.Newvisible" appDisabledRightClick>
  <div class="overlay overlay_white">
    <img [src]='loader' [style.width]="loaderWidth" [style.height]="loaderHeight" />
    <br/>
    <h3>{{LoaderText}}</h3>
  </div>
</div>

<div class="modal" id="RedirectDashBoardModal" data-backdrop="static" data-keyboard="false" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="RedirectDashBoardModalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer" (click)="RedirectTODashBoard()">Okay</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="DisableTranAlertModal1" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Welcome</div>
      <div class="modal-body AlertModalBody">
        <!-- <span *ngIf="UserType==3">
                  To begin your wealth creation journey, set up your account by clicking the button below. 
              </span>
              <span *ngIf="UserType!=3"> -->
        Please complete profile to enable online MF transactions.
        <!-- </span> -->
      </div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer" (click)='GoToClientProfile()'>
          Complete Profile</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="Loader.ReportLoaderVisible" appDisabledRightClick>
  <div class="overlay overlay_white">
    <img [src]='loader' [style.width]="loaderWidth" [style.height]="loaderHeight" />
    <br/>
    <h3 style="white-space: pre-wrap">
      This report may take 1–2 minutes to download.
      <br>
      Thank you for your patience and understanding.
    </h3>
  </div>
</div>